import { render, staticRenderFns } from "./ViewTenant.vue?vue&type=template&id=97b52c58&scoped=true"
import script from "./ViewTenant.vue?vue&type=script&lang=js"
export * from "./ViewTenant.vue?vue&type=script&lang=js"
import style0 from "./ViewTenant.vue?vue&type=style&index=0&id=97b52c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b52c58",
  null
  
)

export default component.exports